<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Koshk</li>
  </ol>
</nav>
<div [hidden]="loading">
  <div class="my-2" translate>Store URL:</div>
  <div class="row">
    <div class="card d-flex flex-row p-3 rounded-25 m-1" style="border-radius: 25px;width: 100%">
      <div class="m-auto" translate *ngIf="this.myBusiness?.storeUsername">
        <a target="_blank" [href]="this.env.getStoreUrl() + this.myBusiness?.storeUsername"> {{ this.env.getStoreUrl() + this.myBusiness?.storeUsername }}</a>
      </div>
      <div class="m-auto" *ngIf="!this.myBusiness?.storeUsername">
        <a class="text-secondary" [routerLink]="'/private/settings-update'" translate>{{ 'Generate Store Username from Settings to generate Store URL' | translate }}</a>
      </div>
    </div>
  </div>
  <div class="my-2" translate>Themes</div>
  <div class="row">
    <app-settings-button-widget *ngIf="!isAccountant && !isSales" [iconPath]="'assets/img/settings-icons/change-invoice-themes.svg'" [title]="'Change Website Themes'" [clickNav]="'/private/theme-settings'"/>
    <app-settings-button-widget *ngIf="!isAccountant && !isSales" [iconPath]="'assets/img/settings-icons/store-icon.svg'" [title]="'Website Pages'" [clickNav]="'/private/webpages'"/>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
